<div *ngIf="activities?.length > 0">
  <h1 class="dash-title">Activity</h1>
  <ul class="dash-list list-unstyled">
    <li class="activity" *ngFor="let activity of activities; trackBy: trackBy">
      <div
        class="activity__gravatar"
        [ngbTooltip]="activity.user.nameOrEmail"
        container="body"
      >
        <ab-gravatar
          class="avatar avatar--default"
          [user]="activity.user"
        ></ab-gravatar>
      </div>
      <div [ngSwitch]="activity.trackableType">
        <ab-group-activity
          *ngSwitchCase="'Group'"
          [activity]="activity"
        ></ab-group-activity>
        <ab-deploy-activity
          *ngSwitchCase="'Deploy'"
          [activity]="activity"
        ></ab-deploy-activity>
        <ab-comment-activity
          *ngSwitchCase="'Comment'"
          [activity]="activity"
        ></ab-comment-activity>
        <ab-user-activity
          *ngSwitchCase="'User'"
          [activity]="activity"
        ></ab-user-activity
        ><span *ngSwitchDefault>&nbsp;{{ activity.activity }}</span>
        <div
          class="activity__created-at"
          title="{{ activity.createdAt | date: 'MMM dd, y HH:mm:ss Z' }}"
        >
          <ab-time-ago [time]="activity.createdAt"></ab-time-ago>
        </div>
      </div>
    </li>
  </ul>
  <div class="col-sm-12 text-center">
    <a class="btn" *ngIf="hasMore && !loading" (click)="loadMore()">Load more</a
    ><span *ngIf="loading"> <ab-spinner-inline></ab-spinner-inline></span>
  </div>
</div>
<div *ngIf="activities?.length === 0">
  <h1 class="dash-title">No Activity Yet</h1>
  <ul class="dash-list list-unstyled">
    <li class="activity">
      As you use Airbrake, you will see a timeline of your project activity
      here.
    </li>
    <li class="activity">
      <div class="activity__icon bkg-color--green-400">
        <i class="glyphicon glyphicon-check"></i>
      </div>
      <div>
        See when a <a href="/users" target="_self">team member</a> resolved an
        error.
      </div>
    </li>
    <li class="activity">
      <div class="activity__icon bkg-color--orange-400">
        <i class="glyphicon glyphicon-ab-comment"></i>
      </div>
      <div>And when a new comment has been made.</div>
    </li>
    <li class="activity">
      <div class="activity__icon bkg-color--blue-400">
        <i class="glyphicon glyphicon-flash"></i>
      </div>
      <div>
        You can also
        <a uiSref="project-deploys" [uiParams]="{ projectId: project.id }"
          >track deploys.</a
        >
      </div>
    </li>
    <li class="activity" *ngIf="project.memberCount === 1">
      <div>
        <a href="/users" target="_self">Add your team members</a> and see each
        other's activity here.
      </div>
    </li>
  </ul>
</div>
